import { G_HEADER__generations_history_button_clone_current } from './history/_buttons_bar/G_HEADER__generations_history_button_clone_current';
import { G_HEADER__generations_history_button_create_new } from './history/_buttons_bar/G_HEADER__generations_history_button_create_new';
import { G_HEADER__generations_history_button_show_hidden_generations } from './history/_buttons_bar/G_HEADER__generations_history_button_show_hidden_generations';
import { G_HEADER__generations_history } from './history/G_HEADER__generations_history';

export function G_HEADER__column_center() {
  return (
    <div className="size-full flex flex-row border ">
      <div className="flex flex-col h-full min-h-0 min-w-0 flex-shrink-0 w-6 border-r  border-component-border">
        <G_HEADER__generations_history_button_create_new />
        <G_HEADER__generations_history_button_clone_current />
        <G_HEADER__generations_history_button_show_hidden_generations />
      </div>
      <G_HEADER__generations_history />
    </div>
  );
}
